export default function padNumber (number) {
  return `${number}`.length == 1 ? `0${number}` : `${number}` 
}